import { Theme } from "./theme.model";

export class ThemeMapper {
  public static mapThemeResponse(response: any): Theme {
    const { themeName, themeProperties, tenant, logo, banner } = response.theme;
    const properties: any = {};
  
    // Mapping theme properties to desired format
    Object.keys(themeProperties).forEach(key => {
      const customKey = ThemeMapper.mapPropertyToCustomKey(key);
      properties[customKey] = themeProperties[key];
    });
  
    return {
      name: themeName,
      properties: properties,
      tenant: tenant,
      logo: logo,
      banner: banner
    };
  }

  private static mapPropertyToCustomKey(property: string): string {
    switch (property) {
      case 'headerBackgroundColour':
        return '--color-header-background';
      case 'headerTextColour':
        return '--color-header-text';
      case 'bodyBackgroundColour':
        return '--color-body-background';
      case 'buttonTextColour':
        return '--color-button-text';
      case 'buttonBorderColour':
        return '--color-button-border';
      case 'buttonBackgroundColour':
        return '--color-button-background';
      case 'primaryColour':
        return '--color-primary';
      case 'secondaryColour':
        return '--color-secondary';
      case 'cardTextColour':
        return '--color-card-text';
      case 'cardBackgroundColour':
        return '--color-card-background';
      case 'interactionTextColour':
        return '--color-interaction-text';
      case 'errorColour':
        return '--color-error';
      case 'cardBorderColour':
        return '--color-card-border';
      case 'darker':
        return 'darker';
      case 'lightest':
        return 'ligthest';
      default:
        return property;
    }
  }
}
